export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6797.6b256966.jpg";